import { TabsContext } from "./Tabs"

import clsx from "clsx"
import { memo, useContext } from "react"
import styled from "styled-components"

const TabsContentContainer = styled.div`
  display: none;

  &.isActive {
    display: block;
  }
`

interface TabsContentProps {
  triggerId: string
  children: React.ReactNode
  className?: string
}

const TabsContent = (props: TabsContentProps) => {
  const { triggerId, children, className } = props

  const { activeTabId } = useContext(TabsContext)

  const isActive = activeTabId === triggerId

  return <TabsContentContainer className={clsx({ isActive }, className)}>{children}</TabsContentContainer>
}

export default memo(TabsContent)
